import { render, staticRenderFns } from "./AccettazioneSsnGruppiConfigEditModal.vue?vue&type=template&id=e16912f2"
import script from "./AccettazioneSsnGruppiConfigEditModal.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnGruppiConfigEditModal.vue?vue&type=script&lang=js"
import style0 from "./AccettazioneSsnGruppiConfigEditModal.vue?vue&type=style&index=0&id=e16912f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports